/* global $ */
import throttle from '../helpers/throttle';

const $window = $(window);
const $header = $('.js-company-header');
const $navigation = $header.find('.js-company-navigation');

const companyHeader = {
  initialize() {
    if ($header.length) {
      this.createEvents();
    }
  },

  createEvents() {
    const throttledScroll = throttle(this.scroll.bind(this), 40, null);

    $window.on('scroll', () => {
      throttledScroll();
    });
  },

  scroll() {
    const top = $window.scrollTop();
    const $sections = $('.js-company-sections section');

    $sections.each((i, section) => {
      const $section = $(section);
      const $sectionId = $section.attr('id');
      const sectionTop = $section.offset().top - $header.outerHeight();
      const sectionBottom = sectionTop + $section.outerHeight();

      if (top >= sectionTop && top <= sectionBottom) {
        $navigation.find('.navigation__link').removeClass('is-active');
        $navigation.find(`.navigation__link[data-jump-target="#${$sectionId}"]`).addClass('is-active');
      }

      if (top + $(window).height() === $(document).height()) {
        $navigation.find('.navigation__link').removeClass('is-active');
        $navigation.find('.navigation__link[data-jump-target="#contact"]').addClass('is-active');
      }
    });
  },
};

export default companyHeader;
